import React, { useState } from "react";
import group1 from "../images/Group (1).png";
import group2 from "../images/Group (2).png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
    attachment: null,
    access_key: process.env.REACT_APP_ACCESS_KEY,
  });

  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const charLimit = 500;

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "message") {
      if (value.length > charLimit) return; // Prevent exceeding limit
      setCharCount(value.length);
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      
      formDataToSend.append(key, formData[key]);
    });

    try {
      const response = await axios.post(
        "https://api.web3forms.com/submit",
        formDataToSend
      );

      if (response.data.success) {
        toast.success(response.data.message);

        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          subject: "",
          message: "",
          attachment: null,
          access_key: process.env.REACT_APP_ACCESS_KEY, 
        });
        setCharCount(0);
      } else {
        toast.error("Please select different languages.");
      }
    } catch (error) {
      toast.error("Network error. Please try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex flex-col justify-center items-center min-h-screen px-4 md:px-8">
      {/* Left image */}
      <img
        src={group1}
        alt="Left decoration"
        className="absolute left-0 bottom-[10px] transform -translate-y-1/2 w-16 md:w-24"
      />

      {/* Contact Form Container */}
      <div className="max-w-[837px] w-full p-6 md:p-10 relative z-10">
        <div className="flex flex-col gap-4 md:gap-8 mb-6 md:mb-12 text-left">
          <h2 className="text-[#ef8702] font-extrabold text-sm md:text-base uppercase">
            WELCOME
          </h2>
          <h1 className="text-[#10281e] text-3xl md:text-5xl font-bold leading-tight">
            Get In Touch With Us
          </h1>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
        <form onSubmit={handleSubmit} className="flex flex-col gap-6 mb-8">
          <input type="hidden" name="access_key" value={formData.access_key} />

          <div className="flex flex-col md:flex-row gap-6">
            <div className="flex-1 flex flex-col gap-2">
              <label className="text-[#10281e] text-sm md:text-base">
                First name
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                className="w-full h-10 border border-[#b5bdba] rounded-lg px-4"
                required
              />
            </div>
            <div className="flex-1 flex flex-col gap-2">
              <label className="text-[#10281e] text-sm md:text-base">
                Last name
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                className="w-full h-10 border border-[#b5bdba] rounded-lg px-4"
                required
              />
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[#10281e] text-sm md:text-base">
              Email address
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="w-full h-10 border border-[#b5bdba] rounded-lg px-4"
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[#10281e] text-sm md:text-base">
              Subject
            </label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleInputChange}
              className="w-full h-10 border border-[#b5bdba] rounded-lg px-4"
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[#10281e] text-sm md:text-base">
              Message
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              className="w-full h-[120px] border border-[#b5bdba] rounded-lg p-3 resize-none"
              required
            />
            <div className="text-sm text-gray-500 text-right">
              {charCount}/{charLimit} characters
            </div>
          </div>

          <button
            type="submit"
            className={`bg-[#1e6c56] text-white px-6 py-3 md:px-12 md:py-4 rounded-lg w-full md:w-fit mx-auto transition-colors ${
              loading ? "opacity-50 cursor-not-allowed" : "hover:bg-[#175443]"
            }`}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit form"}
          </button>
        </form>
      </div>

      {/* Right image */}
      <img
        src={group2}
        alt="Right decoration"
        className="absolute right-0 top-1/4 transform -translate-y-1/2 w-16 md:w-24"
      />
    </div>
  );
};

export default ContactUs;
